import { ContactUsComponent } from './Pages/contact-us/contact-us.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegisterUserComponent } from './Authentication/register-user/register-user.component';
import { ResetPasswordComponent } from './Authentication/reset-password/reset-password.component';
import { LoginComponent } from './Authentication/login/login.component';
import { TemplatesComponent } from './Components/templates/templates.component';
import { AuthGuard } from './auth.guard';
import { ConfirmEmailComponent } from './Authentication/confirm-email/confirm-email.component';
import { UnauthorizedComponent } from './Components/unauthorized/unauthorized.component';
import { ProfileComponent } from './User/profile/profile.component';
import { AdmindashBoardComponent } from './Admin/admindash-board/admindash-board.component';
import { ShowAllUsersComponent } from './Admin/Users/show-all-users/show-all-users.component';
import { AddUserComponent } from './Admin/Users/add-user/add-user.component';
import { AddBlogPostComponent } from './Web/Blog/add-blog-post/add-blog-post.component';
import { BlogPostDetailComponent } from './Web/Blog/blog-post-detail/blog-post-detail.component';
import { BlogPostsComponent } from './Web/Blog/blog-posts/blog-posts.component';
import { ShowBlogPostComponent } from './Web/Blog/show-blog-post/show-blog-post.component';
import { ShowContactsComponent } from './Web/Pages/show-contacts/show-contacts.component';
import { LogsApplicationComponent } from './Admin/logs-application/logs-application.component';
import { AddPageComponent } from './Web/Pages/add-page/add-page.component';
import { PageDetailComponent } from './Web/Pages/page-detail/page-detail.component';
import { ShowPagesComponent } from './Web/Pages/show-pages/show-pages.component';
import { LockScreenComponent } from './Authentication/lock-screen/lock-screen.component';
import { QrCodeComponent } from './Users/qr-code/qr-code.component';
import { NewProvidersComponent } from './Admin/new-providers/new-providers.component';
import { NewsDetailComponent } from './Administrator/news-detail/news-detail.component';
import { NotificationsComponent } from './Admin/Notifications/Notifications.component';
import { BusinessInsightDashboardComponent } from './BusinessInsights/business-insight-dashboard/business-insight-dashboard.component';
import { EnsightsComponent } from './BusinessInsights/ensights/ensights.component';
import { EnsightsDetailsComponent } from './BusinessInsights/ensights-details/ensights-details.component';
import { AdminComminSoonComponent } from './Components/admin-commin-soon/admin-commin-soon.component';
import { EconomicChatComponent } from './OpenAPI/economic-chat/economic-chat.component';
import { GetUserIntersetsComponent } from './User/get-user-intersets/get-user-intersets.component';
import { UserInterestNewsComponent } from './User/user-interest-news/user-interest-news.component';
import { UsercontactsComponent } from './User/usercontacts/usercontacts.component';
import { MainMenuPageMobieComponent } from './Mobile/main-menu-page-mobie/main-menu-page-mobie.component';
import { NewsTypesWindowComponent } from './Mobile/news-types-window/news-types-window.component';
import { BusinessLeadsComponent } from './AISections/business-leads/business-leads.component';
import { AIFilteredNewsAlertsComponent } from './AISections/ai-filtered-news-alerts/ai-filtered-news-alerts.component';
import { TailoredBusinessOpportunitiesComponent } from './AISections/tailored-business-opportunities/tailored-business-opportunities.component';
import { BusinessInsightsComponent } from './AISections/business-insights/business-insights.component';
import { CompetitiveIntegenceComponent } from './AISections/competitive-integence/competitive-integence.component';
import { MarketTrendsComponent } from './AISections/market-trends/market-trends.component';
import { HomepageAPPComponent } from './Components/homepage-app/homepage-app.component';
import { EmailSetupPageComponent } from './Users/email-setup-page/email-setup-page.component';
import { NetworkingSuggectionsComponent } from './AISections/networking-suggections/networking-suggections.component';
import { SettingComponent } from './User/setting/setting.component';
import { DeleteMyAccountComponent } from './User/delete-my-account/delete-my-account.component';
import { CombineNavMobileComponent } from './Navigation/combine-nav-mobile/combine-nav-mobile.component';
import { UsersNavPageComponent } from './Navigation/users-nav-page/users-nav-page.component';
import { PagesNavPageComponent } from './Navigation/pages-nav-page/pages-nav-page.component';
import { BlogNavPageComponent } from './Navigation/blog-nav-page/blog-nav-page.component';
import { UserInterestManuComponent } from './Navigation/user-interest-manu/user-interest-manu.component';
import { SiteSettingComponent } from './Navigation/site-setting/site-setting.component';
const routes: Routes = [
  {
    path:"templates",
    component:TemplatesComponent,
  },
  {
    path:"login",
    component:LoginComponent,
  },
  {
    path:"UserInterest",
    component:UserInterestNewsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"EditUserInterest",
    component:GetUserIntersetsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"register",
    component:RegisterUserComponent,
  },
  {
    path:"forgot",
    component:ResetPasswordComponent
  },
  // {
  //   path:"touchConnect",
  //   component:LinktreDashBoardComponent,
  //   canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  // },
  {
    path:"newsProvider/:id",
    component:NewProvidersComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"newsProviderDt/:id",
    component:NewsDetailComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  // {
  //   path:"setting",
  //   component:LinktreeSettingComponent,
  //   canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  // },
  {
    path:"userContacts",
    component:UsercontactsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"sitesetting",
    component:SiteSettingComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"AccountSetting",
    component:SettingComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  // {
  //   path:"analytics",
  //   component:LinktreeAnalyticsComponent,
  //   canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  // },
  {
    path:"BusinessInsight",
    component:BusinessInsightDashboardComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"EconomicAssistance",
    component:EconomicChatComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"NotificationSettingsManue",
    component:CombineNavMobileComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"UsersManuePage",
    component:UsersNavPageComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"PagesManuePage",
    component:PagesNavPageComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"BlogsManuePage",
    component:BlogNavPageComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"BusinessInsight/:id",
    component:EnsightsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"BusinessInsightDt/:id",
    component:EnsightsDetailsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"Noitifications",
    component:NotificationsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"confirmEmail",
    component:ConfirmEmailComponent,
  },
  {
    path:"commingSoon",
    component:AdminComminSoonComponent,
  },
  {
    path:"Locked",
    component:LockScreenComponent,
    canActivate: [AuthGuard]
  },
  {
    path:"qrCode",
    component:QrCodeComponent,
    canActivate: [AuthGuard]
  },
  {
    path:"Admin",
    component:AdmindashBoardComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"users",
    component:ShowAllUsersComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"adduser",
    component:AddUserComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"unauthorized",
    component:UnauthorizedComponent,
  },
  {
    path:"addPage",
    component:AddPageComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"showPages",
    component:ShowPagesComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"CompanyPage/:id",
    component:PageDetailComponent
  },
  {
    path:"addblogPost",
    component:AddBlogPostComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"showPosts",
    component:ShowBlogPostComponent,
  },
  {
    path:"blogposts",
    component:BlogPostsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"logs",
    component:LogsApplicationComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"showPostsdetail/:id",
    component:BlogPostDetailComponent
  },
  {
    path:"contact",
    component:ContactUsComponent
  },
  {
    path:"showcontacts",
    component:ShowContactsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator'] }
  },
  {
    path:"bussinessLeadPage",
    component:BusinessLeadsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"AIFilterNews",
    component:AIFilteredNewsAlertsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"MarketTrends",
    component:MarketTrendsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"UserInterestManu",
    component:UserInterestManuComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"NetowringSuggections",
    component:NetworkingSuggectionsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"BusinessOporunity",
    component:TailoredBusinessOpportunitiesComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"BusinessInsights",
    component:BusinessInsightsComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"Competitiveint",
    component:CompetitiveIntegenceComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"Market Trends",
    component:CompetitiveIntegenceComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"ManueDash",
    component:MainMenuPageMobieComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"DeleteMyAccount",
    component:DeleteMyAccountComponent,
    canActivate: [AuthGuard], data: { roles: ['Administrator','User'] }
  },
  {
    path:"EmailDevelery",
    component:EmailSetupPageComponent
  },
  {
    path:"EconimicNews",
    component:NewsTypesWindowComponent
  },
  {
    path:"",
    component:HomepageAPPComponent
  },
  {
    path:"**",
    component:ProfileComponent
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
